import { MuiThemeProvider } from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import { WithStyles } from 'decorators/withStyles';
import { IToastMessages } from 'interfaces/theme';
import * as React from 'react';
import { PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';

import ColorPicker from './ColorPicker';

interface IProps {
  classes?: any;
}

interface IState {
  model: IToastMessages;
}

@WithStyles(() => ({
  component: {
    height: 192
  }
}))
export default class ToastMessages extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = { model: null };
  }

  componentDidMount() {
    themeCustomizerService
      .getData()
      .pipe(
        rxjsOperators.logError(),
        rxjsOperators.bindComponent(this),
        rxjsOperators.map(model => model.toastMessages)
      )
      .subscribe(model => {
        this.setState({ model });
      });
  }

  onChangeBackground = (color: string) => {
    themeCustomizerService.setData({
      toastMessages: {
        ...this.state.model,
        bgColor: color
      }
    });
  };

  onChangeFontColor = (color: string) => {
    themeCustomizerService.setData({
      toastMessages: {
        ...this.state.model,
        font: {
          ...this.state.model.font,
          color
        }
      }
    });
  };

  render() {
    const { classes } = this.props;
    const { model } = this.state;

    if (!model) {
      return null;
    }

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <div className={classes.component}>
          <ColorPicker value={model.bgColor} label="Cor do Fundo" handleChangeColor={this.onChangeBackground} />
          <ColorPicker label="Cor das Letras" value={model.font.color} handleChangeColor={this.onChangeFontColor} />
        </div>
      </MuiThemeProvider>
    );
  }
}
